<template>
  <div class="upload">
    <el-upload class="avatar-uploader" :action="action" :show-file-list="false" :before-upload="beforeAvatarUpload">
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>

<script>
import CosAuth from '../plugins/cos-auth.min.js'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  props: {
  	propsimageUrl: {
  		type: String,
  		default: ''
  	}
  },
  data () {
    return {
      imageUrl: this.propsimageUrl,
      action: ''
    }
  },
  watch: {
    propsimageUrl (newVal) {
      this.imageUrl = newVal
    }
  },
  methods: {
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt20M = file.size / 1024 / 1024 < 20

      var allowupload = true
      if (!isJPG && !isPNG) {
        allowupload = false
        this.$message.error('仅限JPG,PNG格式!')
      }
      if (!isLt20M) {
        allowupload = false
        this.$message.error('上传图片大小不能超过 20MB!')
      }

      if (allowupload) {
        this.apiGetTencentyunCosSts(file)
      }
      return allowupload
    },
    camSafeUrlEncode: function (str) {
      return encodeURIComponent(str)
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A')
    },
    apiGetTencentyunCosSts: function (file) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetTencentyunCosSts, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            var Key = 'static/' + Vue.prototype.FunGetUUID() + file.name // 这里指定上传目录和文件名
            var auth = CosAuth({
              SecretId: response.data.Tmpsecretid,
              SecretKey: response.data.Tmpsecretkey,
              Method: 'PUT',
              Pathname: '/' + Key
            })

            var XCosSecurityToken = response.data.Sessiontoken
            var url = response.data.Prefix + that.camSafeUrlEncode(Key).replace(/%2F/g, '/')
            var xhr = new XMLHttpRequest()
            xhr.open('PUT', url, true)
            xhr.setRequestHeader('Authorization', auth)
            XCosSecurityToken && xhr.setRequestHeader('x-cos-security-token', XCosSecurityToken)
            xhr.upload.onprogress = function (e) {
              Vue.prototype.FunLogInfo('上传进度 ' + (Math.round(e.loaded / e.total * 10000) / 100) + '%')
            }
            xhr.onload = function () {
              if (/^2\d\d$/.test('' + xhr.status)) {
                // var ETag = xhr.getResponseHeader('etag');
                that.$emit('change', url)
              } else {
                Vue.prototype.FunLogInfo('文件 ' + Key + ' 上传失败，状态码：' + xhr.status)
              }
            }
            xhr.onerror = function () {
              Vue.prototype.FunLogInfo('文件 ' + Key + ' 上传失败，请检查是否没配置 CORS 跨域规则')
            }
            xhr.send(file)
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-uploader{
    margin-right: 20px;
}
/deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
/deep/ .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.upload{
    display: flex;
    padding-top: 15px;
}
</style>
